/**
 * Created by zhongzhengkai on 2017/7/17.
 */

import { doGet, doPost, } from "./common-func";
import { setMenus, setToken, setUserInfo, } from "./temp-cache";

var env = __env__;
var projEnv = require(`../../config/${env}.env`);

export const redemptionRoles = [
  "REDEMPTION-Dealer",
  "PCN-CRM",
  "BS-CRM",
  "E-VOUCHER",
  "PCCC",
  "BS_ADMIN",
  "PCN-REF",
  "PCN-DOR",
  "PCN-EOT",
  "REDEMPTION-CRM-REGION-SOUTH",
  "REDEMPTION-PCN-REGION-SOUTH",
];

export const goodWillRoles = ["GOODWILL-Dealer", "GOODWILL-PCN"];

export const referralPlatformRoles = [
  "Referral-Platform-Dealer",
  "Referral-Platform-PCN",
  "Referral-Platform-Region",
];

export const giftRoles = ["Gift-Dealer"];

export const porscheClubRoles = [
  "PorscheClub-Dealer",
  "PorscheClub-Region",
  "PorscheClub-PCN",
];

export const cmPortalRoles = [
  "Crm-Portal-Management",
];

var hasGoodWillRole = false;
var hasGiftRole = false;
var hasPorscheClubRole = false;
var hasReferralPlatformRole = false;
var hasCMPortalRole = false;

//login
export const doLogin = (postBody, needPersistence, cb, needJump = true) => {
  doPost(
    "/api/v2/account/sign-in",
    postBody,
    (reply, { code, errorMessage }) => {
      if (errorMessage) {
        cb({ code, errorMessage });
        return;
      }
      setToken(reply.token, needPersistence);
      getRoleByToken(reply.token, needJump, cb);
    },
    { throwError: true }
  );
};

//forget password
export const forgetPassword = (postBody, cb) => {
  doPost("/api/v2/account/awardForgetPasswordSendMail", postBody, (reply) => {
    cb(reply);
  });
};

/**
 * 根据当前用户的经销商信息
 * @param {Function} cb
 */
export const getUserInfo = (cb) => {
  doGet(
    "/api/kpi/getUserInfo",
    (reply, err) => {
      cb(reply, err);
    },
    { throwError: true }
  );
};

/**
 *
 * @param token
 * @param needJump 是否需要走条件逻辑
 * @param cb
 */
export const getRoleByToken = (token, needJump, cb) => {
  doGet(
    "/api/v2/account/" + token,
    (userInfo, replyArgs) => {
      let { code, errorMessage } = replyArgs;
      if (code == "0") {
        userInfo.tokenValid = true;
        hasGoodWillRole = false;
        hasReferralPlatformRole = false;
        hasGiftRole = false;
        hasPorscheClubRole = false;
        hasCMPortalRole= false;

        setUserInfo(
          userInfo.name,
          userInfo.thirdPartyDealerCode,
          userInfo.area,
          userInfo.loginName,
          userInfo.dealerCode,
          userInfo.userType
        );
        setMenus(userInfo.menus);
        if (needJump) {
          var roles = userInfo.roles;
          for (var i = 0; i < roles.length; i++) {
            for (var k = 0; k < redemptionRoles.length; k++) {
              if (roles[i].name == redemptionRoles[k]) {
                hasReferralPlatformRole = true;
                break;
              }
            }

            for (var k = 0; k < goodWillRoles.length; k++) {
              if (roles[i].name == goodWillRoles[k]) {
                hasGoodWillRole = true;
                break;
              }
            }

            for (var k = 0; k < referralPlatformRoles.length; k++) {
              if (roles[i].name == referralPlatformRoles[k]) {
                hasReferralPlatformRole = true;
                break;
              }
            }

            for (var k = 0; k < giftRoles.length; k++) {
              if (roles[i].name == giftRoles[k]) {
                hasGiftRole = true;
                break;
              }
            }

            for (var k = 0; k < porscheClubRoles.length; k++) {
              if (roles[i].name == porscheClubRoles[k]) {
                hasPorscheClubRole = true;
                break;
              }
            }
            for (var k = 0; k < cmPortalRoles.length; k++) {
              if (roles[i].key == cmPortalRoles[k]) {
                hasCMPortalRole = true;
                break;
              }
            }
          }
          userInfo.hasGoodWill = hasGoodWillRole;
          userInfo.hasReferralPlatform = hasReferralPlatformRole;
          userInfo.hasGift = hasGiftRole;
          userInfo.hasCMPortalRole = hasCMPortalRole;
          userInfo.hasPorscheClub = hasPorscheClubRole;
          userInfo.hasEtmt = false;
          if (userInfo.permissions) {
            for (var i = 0; i < userInfo.permissions.length; i++) {
              if (userInfo.permissions[i].key === "EVENT_PC_LOGIN") {
                userInfo.hasEtmt = true;
              }
            }
          }

          cb(userInfo);
          return false;
        } else {
          cb(userInfo);
          return false;
        }
      } else {
        userInfo.success = true;
        userInfo.tokenValid = false;
        userInfo.hasGoodWill = false;
        userInfo.hasReferralPlatform = false;
        userInfo.hasGift = false;
        userInfo.hasPorscheClub = false;
        userInfo.hasEtmt = false;
        cb(userInfo, "");
        return false;
      }
    },
    { throwError: true }
  );
};

//获取当前周期信息
export const peroidInfo = (competition, cb) => {
  doGet(`/api/news/getCurrentPeriod?competition=${competition}`, (reply) => {
    cb(reply);
  });
};

//获取JWT
export const getJwtByKey = (jwtKey, cb) => {
  doGet(
    "/api/iam/v1/jwt/" + jwtKey,
    (reply) => {
      cb(reply);
    },
    { attachPrefix: false }
  );
};

//点击牌子记录登录log
export const LoginLog = (project, loginName, cb) => {
  doGet("/services/porsche/api/crm-portal/management/log/login?project=" + project + "&loginName=" + loginName, (reply) => {
    cb(reply);
  });
};

//获取新referral灰度经销商列表
export const getNewReferralPilotDealers = (cb) => {
  doGet(
    "/api/crm-portal/custom/new-referral/dealer/pilot",
    (reply) => {
      cb(reply);
    },
    { attachPrefix: false }
  );
};



// WEBPACK FOOTER //
// ./src/base/api.js